// extracted by mini-css-extract-plugin
export default {"geo-row":"Geo_geo-row__HMxK3","geo-item":"Geo_geo-item__INQbh"};